import { IFilters } from 'Components/flowChart/types';
import { countFilterSegments } from 'Components/flowChart/utils';

export const getFilterInfoBlast = ({
	includedFilters,
	excludedFilters,
}: {
	includedFilters: IFilters;
	excludedFilters: IFilters;
}) => {
	let segmentType = '';
	let userType = '';
	let numIncludedSegments = 0;
	let numExcludedSegments = 0;
	let numIncludedUsers = 0;
	let numExcludedUsers = 0;

	for (const { AND } of includedFilters.OR) {
		const conditionType = AND[0].conditionType!;

		if (['customer_segment', 'user_segment'].includes(conditionType)) {
			segmentType = conditionType;
			numIncludedSegments = countFilterSegments({ OR: [{ AND }] });
		}
		if (['customer_id', 'user_id'].includes(conditionType)) {
			userType = conditionType;
			numIncludedUsers = AND[0].value.length;
		}
	}

	for (const { AND } of excludedFilters.OR) {
		const conditionType = AND[0].conditionType!;

		if (['customer_segment', 'user_segment'].includes(conditionType)) {
			segmentType = conditionType;
			numExcludedSegments = countFilterSegments({ OR: [{ AND }] });
		}
		if (['customer_id', 'user_id'].includes(conditionType)) {
			userType = conditionType;
			numExcludedUsers = AND[0].value.length;
		}
	}

	return {
		segmentType,
		userType,
		numIncludedSegments,
		numExcludedSegments,
		numIncludedUsers,
		numExcludedUsers,
	};
};
